import { apiClient } from "./apiClient";

/**
 * Request deletion of the current user's account.
 * Begins a grace period after which the account is permanently deleted.
 *
 * @param deleteEntries          When true, entries are hard-deleted together with the account after the grace period.
 * @param hideEntriesDuringGrace When true (requires deleteEntries=true), entries are soft-deleted immediately
 *                               so they are hidden during the grace period. Restored on cancellation.
 */
export const requestAccountDeletion = (
  deleteEntries: boolean,
  hideEntriesDuringGrace: boolean
): Promise<void> =>
  apiClient.post<void>(
    `/api/profile/me/deletion?deleteEntries=${deleteEntries}&hideEntriesDuringGrace=${hideEntriesDuringGrace}`,
    undefined
  );

/**
 * Cancel a pending account deletion during the grace period.
 * Restores the user's active status and any entries that were hidden during the grace period.
 */
export const cancelAccountDeletion = (): Promise<void> =>
  apiClient.delete<void>("/api/profile/me/deletion");